module.exports = __webpack_public_path__ + "static/media/28-active.d74ec5fa.png";